<h2>Orders</h2>
<div class="mobile-search-filters-row">
  <div class="search-wrapper">
    <span class="p-input-icon-right">
      <input type="text" pInputText placeholder="Search Order" [formControl]="searchControl" />
      <i class="pi pi-search input-icon-right"></i>
    </span>
  </div>
  <!-- Mobile Orders Filters -->
  <app-mobile-orders-filters
    [sortOptions]="sortOptions"
    [statusOptions]="statusOptions"
    [(visible)]="mobileFiltersVisible"
    [(selectedStatus)]="selectedStatus"
    [(selectedSortOption)]="selectedSortOption"
    (applyFilters)="onMobileFiltersApplied()"
  />
</div>

<div class="grid formgrid">
  <div class="col-12 mb-2 lg:col-4 lg:mb-0 desktop-search">
    <span class="p-input-icon-right">
      <input
        type="text"
        pInputText
        placeholder="{{ 'COMMON.search' | translate }}"
        [formControl]="searchControl"
      />
      <i class="pi pi-search input-icon-right"></i>
    </span>
  </div>
  <div class="col-12 mb-2 lg:col-4 lg:mb-0 desktop-filters">
    <p-select
      [style]="{ minWidth: '100%' }"
      [options]="statusOptions"
      [(ngModel)]="selectedStatus"
      placeholder="{{ 'ORDER.status' | translate }}"
      (onChange)="onStatusChange($event.value)"
      [showClear]="true"
    ></p-select>
  </div>
  <div class="col-12 mb-2 lg:col-4 lg:mb-0 desktop-filters">
    <p-select
      [style]="{ minWidth: '100%' }"
      [options]="sortOptions"
      [(ngModel)]="selectedSortOption"
      placeholder="{{ 'ORDER.sort' | translate }}"
      (onChange)="onSortChange($event.value)"
      [showClear]="!!selectedSortOption"
    ></p-select>
  </div>
</div>
@if (isLoading) {
  <div class="flex justify-content-center align-items-center" style="height: 50vh">
    <p-progressSpinner ariaLabel="Loading" />
  </div>
} @else if (orders.length > 0) {
  <div class="orders-list">
    @for (order of orders; track order.id) {
      <p-card class="orders-card">
        <div class="orders-item-header flex justify-content-between align-items-center">
          <h3 class="m-0">Order #{{ order.uuid }}</h3>
          <app-button
            [routerLink]="['/my-account/orders', order.uuid]"
            icon="pi pi-arrow-right"
            buttonStyle="outlined"
            label="DETAILS"
          ></app-button>
        </div>
        <p-divider />
        <div class="orders-item-info flex flex-wrap gap-5 lg:gap-6">
          <div class="orders-item-date">
            <span class="text-600">Order Date</span>
            <p class="m-0">{{ order.created_at | localeDateTime }}</p>
          </div>
          <div class="orders-item-status">
            <span class="text-600">Status</span>
            <p-tag
              [value]="getOrderStatus(order.status)"
              [severity]="getOrderStatusSeverity(order.status)"
              [rounded]="true"
            ></p-tag>
          </div>
          <div class="orders-item-payment-status">
            <span class="text-600">Payment Status</span>
            <p-tag
              [value]="order.payment_status | titlecase"
              [severity]="getPaymentStatusSeverity(order.payment_status)"
              [rounded]="true"
            ></p-tag>
          </div>
          <div class="orders-item-code">
            <span class="text-600">Code Applied</span>
            @if (order.total_without_discounts !== order.total) {
              <p-tag value="Applied" severity="success" rounded></p-tag>
            } @else {
              <p-tag value="Not Applied" severity="info" rounded></p-tag>
            }
          </div>
          <div class="orders-item-paid ml-auto">
            <span class="text-600">Paid Amount</span>
            <p>
              {{
                order.total
                  | price
                  | usdPipe: 'USD' : 'symbol' : '1.2-2' : order.display_currency ?? null
              }}
            </p>
          </div>
        </div>
      </p-card>
    }
  </div>
  <p-paginator
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    [first]="(currentPage - 1) * pageSize"
    (onPageChange)="onPageChange($event)"
    [rowsPerPageOptions]="[5, 10, 15]"
  ></p-paginator>
} @else if (searchTerm || selectedStatus) {
  <app-empty-page [message]="'ORDER.noResults' | translate" />
} @else {
  <app-empty-page [message]="'ORDER.noOrders' | translate" />
}
